import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../css/Documentation.css"; 
import { fetchModifications, fetchReferentiels, fetchMigrations } from "./Fonctions_Communications_API";

import FAQ from "./FAQ";


//Cette fonction pour masquer les emails des personnes qui ont fait des modifications
const maskEmail = (email) => {
  const [name, domain] = email.split("@");
  return `${name.slice(0, 2)}***********@${domain}`;
};


const ReferentielsList = ({ referentiels }) => {
  const getNomComplet = (nom) => {
    switch (nom.toLowerCase()) {
      case 'cnam':
        return 'Caisse nationale de l\'Assurance Maladie';
      case 'rpps':
        return 'Répertoire partagé des professionnels de santé';
      case 'alignements':
        return 'Alignements CNAM/RPPS proposés par Interhop';
      case 'cnam_ps':
        return 'Liste des professionnels de santé de la CNAM';
      case 'finess':
        return 'Fichier national des établissements sanitaires et sociaux';
      default:
        return nom; // Si aucun des cas ci-dessus, on retourne le nom tel quel
    }
  };

  return (
    <div>
      <h2 id="referentiels" className="section-title">2. Référentiels utilisés</h2>
      <p className="section-content">Voici les référentiels utilisés dans l'application :</p>

      <ul>
        {referentiels.map((referentiel, index) => {
          const { nom, date, lien } = referentiel;

          // Formater la date
          const formattedDate = new Date(date).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });

          // Utiliser la fonction getNomComplet pour obtenir le nom long
          const nomComplet = getNomComplet(nom);

          return (
            <li key={index} className="referentiel-item">
              <h3>{nomComplet}</h3>
              <p>Date d'utilisation: {formattedDate}</p>
              <a href={lien} target="_blank" rel="noopener noreferrer">Voir le référentiel</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};




export default function Documentation() {

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  const [modificationsHistoriques, setModificationsHistoriques] = useState([]);
  const [migrationsPraticiens, setMigrationsPraticiens] = useState([]);
  const [referentiels, setReferentiels] = useState([]);

  //Pour récupérer les modifications faites par les utilisateurs de la cartographie
  useEffect(() => {
    const fetch = async () => {
      await fetchModifications(setModificationsHistoriques);
      await fetchReferentiels(setReferentiels);
      await fetchMigrations(setMigrationsPraticiens);
    };
    fetch();
  }, []);

  


  return (
    <div className="documentation">
  <h1 className="documentation_title">Documentation d'annuaire</h1>


  <h2 id="historique" className="section-title">1. Historique des modifications</h2>
  <h3 className="section-content">Cette section présente l'historique des modifications apportées aux établissements de santé.</h3>
  {modificationsHistoriques.length > 0 ? (
    <div className="table-container">
    <table className="table">
    <thead className="table-header">
      <tr>
        <th>Numéro FINESS</th>
        <th>Email Modificateur</th>
        <th>Raison Sociale</th>
        <th>Type de Modification</th>
        <th>Modifications</th>
        <th>Validé ?</th>
      </tr>
    </thead>
    <tbody className="table-body">
      {modificationsHistoriques.map((modification, index) => (
        <tr className="table-row" key={index}>
          <td className="table-cell">{modification.numero_finess}</td>
          <td className="table-cell">{maskEmail(modification.email_modificateur)}</td>
          <td className="table-cell">{modification.modification.rs}</td>
          <td className="table-cell">{modification.type_de_modification}</td>
          <td className="table-cell">
            <ul className="modifications-list">
              {Array.isArray(modification.colonnes_modifiees) &&
              modification.colonnes_modifiees.length > 0 ? (
                modification.colonnes_modifiees.map((colonne, i) => (
                  <li className="modification-item" key={i}>
                    <strong className="modification-item__strong">{colonne} :</strong> {
                    typeof modification.modification[colonne] === "boolean"
                      ? modification.modification[colonne] ? "Oui" : "Non"
                      : modification.modification[colonne]}
                  </li>
                ))
              ) : (
                <li className="no-modifications">Aucune modification</li>
              )}
            </ul>
          </td>
          <td className="table-cell">
            {modification.validée ? "✅" : "❌"}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  </div>
     
  ) : (
    <p className="no-modifications">Aucune modification enregistrée pour les établissements.</p>
  )}
  <h3 className="section-content" style={{marginTop:'100px'}}>Cette section présente l'historique des migrations de praticiens.</h3>
  {migrationsPraticiens.length > 0 ? (
        <div className="table-container">

    <table className="table">
    <thead className="table-header">
      <tr>
        <th>Etablissement initial</th>
        <th>N°RPPS</th>
        <th>Nom</th>
        <th>Prénom</th>
        <th>Profession</th>
        <th>Type de modification</th>
        <th>Nouvel établissement</th>
      </tr>
    </thead>
    <tbody className="table-body">
      {migrationsPraticiens.map((migration, index) => (
        <tr className="table-row" key={index}>
          <td className="table-cell">{migration.nom_etablissement_depart}</td>
          <td className="table-cell">{migration.rpps_id}</td>
          <td className="table-cell">{migration.nom}</td>
          <td className="table-cell">{migration.prenom}</td>
          <td className="table-cell">{migration.profession}</td>
          <td className="table-cell">{migration.type_de_modification}</td>
          <td className="table-cell">{migration.nom_etablissement_arrive}</td>
          
        </tr>
      ))}
    </tbody>
  </table>
  </div>
     
  ) : (
    <p className="no-modifications">Aucune migration de praticiens enregistrée.</p>
  )}
  <ReferentielsList referentiels={referentiels} />
  <h2 id="historique" className="section-title">3. FAQ</h2>
  <FAQ/>
</div>

  );
}
